import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const VendasDeProdutosContainer = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  place-content: center;

  align-items: center;
  justify-items: center;

  h1 {
    width: 100%;

    text-align: center;

    margin-top: 24px;
    color: #2c73e9;
  }
`;

export const Frame = styled.div`
  border: 2px solid;
  border-color: #2c73e9;
  border-radius: 8px;
  width: 95%;

  margin: 16px;
  padding: 16px;

  display: flex;
  flex-direction: column;
  place-content: center;

  align-items: center;
  justify-items: center;

  color: #2c73e9;
  font-size: 24px;

  strong {
    width: 100%;
    text-align: center;
  }

  .mes-tabela {
    width: 100px;
  }

  div {
    display: flex;
    width: 100%;

    justify-content: space-between;
    margin-top: 4px;
  }
`;
